import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "title", "list", "panel", "backBtn", "footer"]

  #dirty = false
  #trail = []

  open({ params: { filterLabel, filterPanel } }) {
    this.#trail = []
    this.#go(filterLabel, filterPanel)
    this.#show()
  }

  openList() {
    this.#trail = []
    this.#setTitle("Filters & Sort")
    this.#showList()
    this.#show()
  }

  navigate({ params: { filterLabel, filterPanel } }) {
    this.#go(filterLabel, filterPanel)
  }

  back() {
    this.#trail.pop()
    const previous = this.#trail.at(-1)
    if (previous) return this.#display(previous)

    this.#setTitle("Filters & Sort")
    this.#showList()
  }

  markDirty() {
    this.#dirty = true
  }

  close() {
    if (this.#dirty) this.#applyAllFilters()
    this.#closeDrawer()
  }

  get #form() {
    return this.element.querySelector("form[data-controller='side-filter']")
  }

  #applyAllFilters() {
    const sideFilter = this.application.getControllerForElementAndIdentifier(this.#form, "side-filter")
    sideFilter?.applyFilters()
  }

  disconnect() {
    this.#unlockPage()
  }

  #show() {
    this.#dirty = false
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.body.style.overscrollBehavior = "contain"
    this.#toggleIntercomLauncher(false)
  }

  #closeDrawer() {
    this.overlayTarget.classList.add("hidden")
    this.#unlockPage()
  }

  #unlockPage() {
    document.body.style.overflow = ""
    document.body.style.overscrollBehavior = ""
    this.#toggleIntercomLauncher(true)
  }

  #toggleIntercomLauncher(visible) {
    window.Intercom?.("update", { hide_default_launcher: !visible })
  }

  #setTitle(label) {
    this.titleTarget.textContent = label
  }

  #go(label, panel) {
    const step = { label, panel }
    this.#trail.push(step)
    this.#display(step)
  }

  #display({ label, panel }) {
    this.#setTitle(label)
    this.#showPanel(panel)
  }

  #showPanel(panelName) {
    this.listTarget.classList.add("hidden")
    this.panelTargets.forEach(p => p.classList.toggle("hidden", p.dataset.panel !== panelName))
    this.backBtnTarget.classList.remove("hidden")
    this.titleTarget.classList.remove("pl-10")
    const panel = this.panelTargets.find(p => p.dataset.panel === panelName)
    this.#showFooter(panel?.dataset.footer)
  }

  #showList() {
    this.listTarget.classList.remove("hidden")
    this.panelTargets.forEach(p => p.classList.add("hidden"))
    this.backBtnTarget.classList.add("hidden")
    this.titleTarget.classList.add("pl-10")
    this.#showFooter()
  }

  #showFooter(name = "default") {
    this.footerTargets.forEach(f => f.classList.toggle("hidden", f.dataset.footer !== name))
  }
}
